// extracted by mini-css-extract-plugin
export default {"resizable_popup":"DebugCC_resizable_popup__4gmhK","scrollable_content":"DebugCC_scrollable_content__LUwLK"};